import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as WishlistActions from '../wishlist/wishlist.action';
import {  map, mergeMap} from 'rxjs';
import { WishlistService } from '../../app/core/services/wishlist/wishlist.service';
import { Product } from '../../app/shared/interface/home';

@Injectable()
export class WishlistEffects {

  private _actions$ = inject(Actions);
  private wishlistService = inject(WishlistService);  
 

  // Load Wishlist
  loadWishlist$ = createEffect(() =>
    this._actions$.pipe(
      ofType(WishlistActions.loadWishlist),
      mergeMap(() =>
        this.wishlistService.getWishlistData().pipe(
          map(res =>
            WishlistActions.loadWishlistSuccess({ products: res.wishlist.products })
            
          )
          
        )
      )
    )
  );

  // Add Product
addWishlistProduct$ = createEffect(() =>
    this._actions$.pipe(
      ofType(WishlistActions.addWishlistProduct),
      mergeMap(action =>
        this.wishlistService.addWishlistData(action.productId).pipe(
          map(res => {
            console.log("Products : ",res);

            return WishlistActions.addToWishlistSuccess({ productId: action.productId });
          })
        )
      )
    )
  );
  // Remove Product
  removeWishlistProduct$ = createEffect(() =>
    this._actions$.pipe(
      ofType(WishlistActions.removeWishlistProduct),
      mergeMap(action =>
        this.wishlistService.removeWishlistData(action.productId).pipe(
          map(() =>
            WishlistActions.removeFromWishlistSuccess({ productId: action.productId })
          )
        )
      )
    )
  );

  // Clear Wishlist
  clearWishlist$ = createEffect(() =>
    this._actions$.pipe(
      ofType(WishlistActions.clearWishlist),
      mergeMap(() =>
        this.wishlistService.clearWishlistData().pipe(
          map(() => WishlistActions.clearWishlistSuccess())
       
        )
      )
    )
  );
}